<template>
  <div v-if="item">
    <h4>Номер заказа # {{ id }}</h4>
    <div>
      <h6>
        Создан:
        <span class="text-info">{{ item.created_at | dateTimeFormat }} </span>
      </h6>
      <h6>
        Стоимость заказа:
        <span class="text-info"
          >{{ item.price | spaceBetweenNumber }} сум
        </span>
      </h6>
      <h6>
        Оплачено:
        <span class="text-info"
          >{{ item.payment | spaceBetweenNumber }} сум
          <span class="text-bold" v-if="item.price > 0"
            >{{ Math.round((item.payment / item.price) * 100) }}%</span
          >
        </span>
      </h6>
      <h6>
        Бонус с заказа:<span class="text-info">
          {{ item.reward | spaceBetweenNumber }} сум</span
        >
      </h6>
      <h6 v-if="item.customer">
        Заказчик:<span class="text-info"> {{ ` ${item.customer.name}` }}</span>
      </h6>
      <h6 v-if="item.customer">
        Номер телефона:<span class="text-info">
          {{ `${item.customer.phone}` }}</span
        >
      </h6>
      <h6 v-if="item.customer">
        Адрес: <span class="text-info"> {{ `${item.customer.address}` }}</span>
      </h6>
      <h6 v-if="item.customer && item.customer.shop">
        Магазин:
        <span @click="showShop(item.customer.shop.id)" class="link">
          {{ `${item.customer.shop.name}` }}</span
        >
      </h6>
      <h6 v-else>Магазин не установлен</h6>
      <h6>
        Тип оплаты: {{ item.payment_type ? typePay[item.payment_type] : ''}}
      </h6>
    </div>
    <br />
    <fields-list :item="item" :fields="fields" /><button class="btn btn-sm btn-warning btn-icon" @click="updateItem">
      <span class="ti-save"></span>Сохранить заказ
    </button>

    <h4 class="mt-5 mb-1">Оплаты заказа # {{ id }}</h4>
    <payments @deleted="refresh" :id="id" />
    <h4 class="mt-5 mb-1">Товары заказа # {{ id }}</h4>
    <purchases @deleted="refresh" :id="id" :item="item"/>
  </div>
</template>

<script>
import { cardUpdate, cardContent, pushLang } from "@/plugins/functions";
import { mapState } from "vuex";

export default {
  components: {
    purchases: () => import("./Purchases"),
    payments: () => import("./Payments"),
  },
  computed: {
    ...mapState(["lastUpdate"]),
  },
  data: () => ({
    cardLink: "orders",
    cardSetLink: "orders",
    item: null,
    typePay: {
      cash: 'Наличные',
      transfer: 'Без наличные'
    },
    fields: [
      {
        col: " col-12 col-md-12",
        key: "status",
        label: "Статус",
        type: "select",
        modal: "status_order",
      },
      // {
      //   col: " col-12 col-md-12",
      //   key: "is_paid",
      //   label: "Оплачено",
      //   type: "checkbox",
      // },
    ],
  }),
  props: ["id"],
  async created() {
    // this.pushLang();
    this.item = await this.cardContent(this.cardLink, this.id);
  },
  methods: {
    cardUpdate: cardUpdate,
    cardContent: cardContent,
    pushLang: pushLang,
    async refresh() {
      let item = await this.cardContent(this.cardLink, this.id);
      if (item && item["id"]) {
        this.item["price"] = item["price"];
        this.item["payment"] = item["payment"];
        this.item["reward"] = item["reward"];
      }
    },
    async updateItem() {
      let item = await this.cardUpdate(
        this.cardSetLink,
        this.item,
        this.fields
      );
    },
    showShop(shopId = {}) {
      let query = Object.assign({}, this.$route.query);
      if (query["item_shop"] == shopId) {
        return false;
      }

      if (query["item_shop"]) {
        delete query["item_shop"];
      }

      query["item_shop"] = shopId;
      setTimeout(() => {
        this.$router.replace({ query: query });
      }, 20);
    },
  },
  watch: {
    lastUpdate(val) {
      if (val) {
        this.refresh();
      }
    },
  },
};
</script>
<style>
</style>
